'use es6';

import getIn from 'transmute/getIn';
import { UPDATES } from '../constants/keyPaths';
export const getUpdates = getIn(UPDATES);